export const OrderTypeEnum = {
  /** 结算单流程 */
  SETTLEMENT: "00021",
  /** 付款单流程 */
  PAYMENT: "00022",
  /** 对账单流程 */
  RECONCILIATION: "00030",
};

export const BillCycleList = [
  "一期",
  "二期",
  "三期",
  "四期",
  "五期",
  "六期",
  "七期",
  "八期",
  "九期",
  "十期",
  "十一期",
  "十二期",
  "十三期",
  "十四期",
  "十五期",
  "十六期",
  "十七期",
  "十八期",
  "十九期",
  "二十期",
  "二十一期",
  "二十二期",
  "二十三期",
  "二十四期",
  "二十五期",
  "二十六期",
  "二十七期",
  "二十八期",
  "二十九期",
  "三十期",
];
